module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.89889688.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
 ** module id = 157
 ** module chunks = 0
 **/